import { Col, Row } from 'antd';
import { plantApi } from 'api/plantApi';
import { plantInfo } from 'models';
import * as React from 'react';
import style from './ItemPlantList.module.scss';
import moment from 'moment';
import { useAppDispatch } from 'app/hooks';
import { plantActions } from 'features/Plant/plantSlice';

export interface ItemPlantListProps {
  item: plantInfo;
  setIsShowPlantDetail: (value: boolean) => void;
}

export default function ItemPlantList({ item, setIsShowPlantDetail }: ItemPlantListProps) {
  const [itemPlant, setItemPlant] = React.useState<plantInfo>(item);
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    (async () => {
      try {
        const response: plantInfo = await plantApi.fetchPlantInfo({
          type: 'plant_id',
          id: item.id,
        });
        setItemPlant({ ...itemPlant, ...response });
      } catch (error) {
        console.log('Failed to fetch plant details', error);
      }
    })();
  }, []);
  return (
    <Row
      onClick={() => {
        dispatch(plantActions.fetchPlantInfo({ type: 'plant_id', id: item.id }));
        setIsShowPlantDetail(false);
      }}
      className={style.root}
    >
      <Col className={style.item_plant} span={4}>
        {itemPlant.code}
      </Col>
      <Col className={style.item_plant} span={8}>
        {itemPlant.label}
      </Col>
      <Col className={style.item_plant} span={5}>
        {itemPlant.system_size} kW
      </Col>
      <Col className={style.item_plant} span={7}>
        {moment(itemPlant.installation_date).format('YYYY-MM-DD HH:mm:ss')}
      </Col>
    </Row>
  );
}
